:host {
  display: block;
}

/* Add styles for quotes in slides */
vs-slide vs-quote {
  width: 100%;
  display: block;
}
